/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { useRecoilValue } from "recoil";
import { loadedState } from "../../atoms";
import styled from "@emotion/styled";

const BlankDiv = styled.div`
  position: fixed;
  z-index: 200;
  height: 100vh;
  width: 100vw;
  background-color: #eff2f5;
  opacity: 0.5;
  pointer-events: none;
`;

function LoadingBlankOverlay() {
  const loaded = useRecoilValue(loadedState);

  // Remove the overlay in development
  if (process.env.NODE_ENV === "development") return null;

  return (
    <BlankDiv
      css={css`
        display: ${loaded ? "none" : "block"};
      `}
    ></BlankDiv>
  );
}

export default LoadingBlankOverlay;
